/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivFleetEventControllerGetAllParamsGen,
  MrfiktivFleetEventControllerGetAllPostParamsGen,
  MrfiktivFleetEventControllerListParamsGen,
  MrfiktivFleetEventViewModelGen,
  MrfiktivMultipleIdsDtoOptionalGen,
  MrfiktivPageViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class FleetEvents<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Fleet Events
   * @name FleetEventControllerGetAll
   * @summary (FLEET-EVENT-READ) Get all events for fleet vehicles
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/event
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivFleetEventViewModelGen)[] })`
   */
  fleetEventControllerGetAll = (
    { partnerId, fleetId, ...query }: MrfiktivFleetEventControllerGetAllParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivFleetEventViewModelGen[] }, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/event`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Events
   * @name FleetEventControllerGetAllPost
   * @summary (FLEET-EVENT-READ) Get all events for fleet vehicles
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/event
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivFleetEventViewModelGen)[] })`
   */
  fleetEventControllerGetAllPost = (
    { partnerId, fleetId, ...query }: MrfiktivFleetEventControllerGetAllPostParamsGen,
    data: MrfiktivMultipleIdsDtoOptionalGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivFleetEventViewModelGen[] }, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/event`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Events
   * @name FleetEventControllerList
   * @summary (FLEET-EVENT-READ) Get all events in a specific time frame for fleet vehicles
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/event/list
   * @secure
   * @response `200` `(MrfiktivFleetEventViewModelGen)[]` The enumerated events from start to end date
   */
  fleetEventControllerList = (
    { partnerId, fleetId, ...query }: MrfiktivFleetEventControllerListParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivFleetEventViewModelGen[], any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/event/list`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Events
   * @name FleetEventControllerOverdue
   * @summary (FLEET-EVENT-READ) Lists all overdue events for fleet vehicles
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/event/overdue
   * @secure
   * @response `200` `(MrfiktivFleetEventViewModelGen)[]` The overdue events
   */
  fleetEventControllerOverdue = (partnerId: string, fleetId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivFleetEventViewModelGen[], any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/event/overdue`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Events
   * @name FleetEventControllerGetOne
   * @summary (FLEET-EVENT-READ) Get a single event by eventId
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/event/{eventId}
   * @secure
   * @response `200` `MrfiktivFleetEventViewModelGen` The event
   */
  fleetEventControllerGetOne = (partnerId: string, fleetId: string, eventId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivFleetEventViewModelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/event/${eventId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
}
